export default __webpack_public_path__ + "static/animaton-c7e2170df1ea0ec6d2dfbf9e73869e1d.jpg";